import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FileUploaderModel } from './../../../../shared/components/file-uploader/file-uploader.model';
import {Component, ViewChild, Injector, Input} from '@angular/core';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import {PieceActeAttaque} from '../../../../entities/piece-jointe';
import { FileUploaderComponent } from './../../../../shared/components/file-uploader/file-uploader.component';
import {DraftDepotRequeteService} from '../../../draft-depot-requete.service';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {DragulaService} from 'ng2-dragula';

@Component({
    selector: 'jhi-acte-attaque',
    templateUrl: './acte-attaque.component.html',
    styleUrls: ['./acte-attaque.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ActeAttaqueComponent,
            multi: true
        }
    ]
})
export class ActeAttaqueComponent extends BaseControlValueAccessor {

    @ViewChild('acteAttaquesAdder')
    pieceAdder: FileUploaderComponent;

    @Input()
    maxActeAttaquesForMerge: number;

    @Input()
    draftRequeteId: number;

    @Input()
    adderLabel: string;

    @Input()
    acteRequired: boolean;

    acteAttaques: PieceActeAttaque[] = [];

    // --- drag n drop keyboard accessible
    public selectedItem = null;

    constructor(injector: Injector, private draftDepotRequeteService: DraftDepotRequeteService,
                private liveAnnouncer: LiveAnnouncer,
                private dragulaService: DragulaService) {
        super(injector);

        this.dragulaService.drop.subscribe(() => {
            this.liveAnnouncer.announce('élément relaché');
        });

        this.dragulaService.drag.subscribe(() => {
            this.liveAnnouncer.announce('élément selectionné ');
        });
    }

    protected modelValueChanged(value: any): void {
        this.acteAttaques = value;
    }

    onActeAttaqueAdd(file: FileUploaderModel) {
        if (file) {
            this.acteAttaques.push(new PieceActeAttaque(file));
            this.pieceAdder.deleteFile();
        }
        this.onChange(this.acteAttaques);
    }

    onActeAttaqueDelete(index: number, file: FileUploaderModel) {
        if (!file) {
            this.acteAttaques.splice(index, 1);
        }
        this.onChange(this.acteAttaques);
    }

    moveUp(index: number) {
        if (index > 0) {
            this.swapActeAttaques(index - 1, index);
        }
    }

    moveDown(index: number) {
        if (index < this.acteAttaques.length - 1) {
            this.swapActeAttaques(index + 1, index);
        }
    }

    trackByFileApiId(_index: number, item: PieceActeAttaque) {
        return item.fileModel.fileApiId;
    }

    private swapActeAttaques(piece1Index: number, piece2Index: number) {
        const piece1 = this.acteAttaques[piece1Index];
        const piece2 = this.acteAttaques[piece2Index];
        this.acteAttaques[piece2Index] = piece1;
        this.acteAttaques[piece1Index] = piece2;
    }

    get uploadUrl(): string {
        return this.draftDepotRequeteService.buildUploadUrl();
    }

    // --- drag n drop keyboard accessible
    onMoveup(data: any) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    }

    onMovedown(data: any) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    }

    onSelect(data: any) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    }

    onEscape(data: any) {
        console.log('onEscape', data);
        this.selectedItem = null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/justificatifs/acte-attaque/acte-attaque.component.ts